import { Component } from '@theme/component';

class QRBlogArticle extends Component {
  #contentsInitialisedFor = null;

  connectedCallback() {
    super.connectedCallback();
    this.buildContents();
  }

  updatedCallback() {
    super.updatedCallback();
    this.buildContents();
  }

  buildContents() {
    const content = this.querySelector('.blog-post-content');
    if (!content) return;
    this.buildContactLinks(content);
    const contents = this.querySelector('[data-qrb-contents]');
    const list = contents?.querySelector('ol');
    if (!content || !contents || !list) return;

    const headings = [...content.querySelectorAll('h2, h3')].filter((heading) => heading.textContent?.trim() && !heading.closest('[data-qrb-promo]'));
    if (headings.length < 2) {
      contents.hidden = true;
      return;
    }

    const fragment = document.createDocumentFragment();
    headings.forEach((heading, index) => {
      if (!heading.id) {
        const slug = heading.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 70);
        const base = `qrb-${this.dataset.articleId}-${index + 1}-${slug || 'section'}`;
        let candidate = base;
        let suffix = 1;
        while (document.getElementById(candidate)) candidate = `${base}-${suffix++}`;
        heading.id = candidate;
      }
      const item = document.createElement('li');
      if (heading.tagName === 'H3') item.className = 'qrb-toc__subheading';
      const link = document.createElement('a');
      link.href = `#${encodeURIComponent(heading.id)}`;
      link.textContent = heading.textContent.trim();
      item.append(link);
      fragment.append(item);
    });
    list.replaceChildren(fragment);
    content.before(contents);
    const disclosure = contents.querySelector('details');
    const articleId = this.dataset.articleId || '';
    if (disclosure && this.#contentsInitialisedFor !== articleId) {
      disclosure.open = true;
      this.#contentsInitialisedFor = articleId;
    }
    contents.hidden = false;
  }

  buildContactLinks(content) {
    const contacts = [
      { image: '265c93ae-c6c9-45c8-ab24-95ae7f213d5d', href: 'https://twitter.com/quizrunners', label: 'Follow QuizRunners' },
      { image: '5737478b-8d0c-4550-88c3-0c349ed28dea', href: 'mailto:vernevoy@quizrunners.com', label: 'Email Vern' },
    ];
    const images = [...content.querySelectorAll('a > img')];
    const links = [];
    for (const contact of contacts) {
      const image = images.find((candidate) => {
        try {
          const url = new URL(candidate.getAttribute('src') || '', document.baseURI);
          const original = url.hostname === 'ucarecdn.com' && url.pathname.split('/')[1] === contact.image;
          const ownedHost = url.origin === new URL(document.baseURI).origin || url.hostname === 'cdn.shopify.com';
          const ownedPath = url.pathname.includes('/assets/') || url.pathname.includes('/files/');
          const migrated = ownedHost && ownedPath && url.pathname.endsWith('/qr-migrated-' + contact.image + '.webp');
          return original || migrated;
        } catch {
          return false;
        }
      });
      const link = image?.parentElement;
      if (!link || link.getAttribute('href') !== contact.href) continue;
      const existingLabel = link.querySelector('[data-qrb-contact-label]');
      if (!existingLabel && (link.children.length !== 1 || link.textContent.trim())) continue;
      if (!image.classList.contains('qrb-contact-original')) image.classList.add('qrb-contact-original');
      if (image.getAttribute('aria-hidden') !== 'true') image.setAttribute('aria-hidden', 'true');
      if (!link.classList.contains('qrb-contact-link')) link.classList.add('qrb-contact-link');
      if (link.getAttribute('aria-label') !== contact.label) link.setAttribute('aria-label', contact.label);
      if (!existingLabel) {
        const label = document.createElement('span');
        label.setAttribute('data-qrb-contact-label', '');
        label.textContent = contact.label;
        link.append(label);
      }
      links.push(link);
    }
    if (links.length && links.every((link) => link.parentElement === links[0].parentElement) && !links[0].closest('.qrb-author-contact')) {
      const navigation = document.createElement('nav');
      navigation.className = 'qrb-author-contact';
      navigation.setAttribute('aria-label', 'Author contact links');
      links[0].before(navigation);
      navigation.append(...links);
    }
  }
}

if (!customElements.get('qr-blog-article')) customElements.define('qr-blog-article', QRBlogArticle);
